<template>
  <div class="doctor-audit">
    <div class="doctor-item" v-for="(item, index) in doctorList" :key="index">
      <div class="info">
        <div class="avatar">
          <img :src="item.avatar" />
        </div>
        <div class="context">
          <div class="words" v-if="item.name">
            醫生姓名：{{ item.real_name }}
          </div>
          <div class="words" v-else>暱稱：{{ item.nickname }}</div>
          <div class="words">ID：{{ item.uid }}</div>
        </div>
        <div class="context">
          <div class="words">聯繫電話：{{ item.phone }}</div>
          <div class="words" v-if="item.hospital">
            所屬醫院：{{ item.hospital }}
          </div>
          <div class="words">
            審核狀態：{{
              item.isAgree == 0
                ? "待審核"
                : item.isAgree == 1
                ? "審核通過"
                : "審核不通過"
            }}
          </div>
        </div>
      </div>
      <div class="operation" v-if="item.isAgree == 0">
        <div class="no-pass" @click="doNoPass(item.uid)">審核不通過</div>
        <div class="pass" @click="doPass(item.uid)">審核通過</div>
      </div>
    </div>
  </div>
</template>
<script>
import { doctorList, doctorAuditPass, doctorAuditNoPass } from "@/api/user.js";
import { mapGetters } from "vuex";
export default {
  name: "DoctorData",
  components: {},
  data: function() {
    return {
      doctorList: []
    };
  },
  watch: {},
  computed: mapGetters(["userInfo"]),
  created() {},
  async mounted() {
    this.loadData();
    console.log(this.userInfo);
  },
  methods: {
    loadData() {
      doctorList().then(res => {
        console.log(res);
        this.doctorList = res.data;
      });
    },
    doPass(uid) {
      this.$dialog.confirm({
        mes: "確定審核通過?",
        opts: () => {
          doctorAuditPass(uid).then(res => {
            console.log(res);
            this.$dialog.toast({ mes: "處理成功" });
            this.loadData();
          });
        }
      });
    },
    doNoPass(uid) {
      this.$dialog.confirm({
        mes: "確定審核不通過?",
        opts: () => {
          doctorAuditNoPass(uid).then(res => {
            console.log(res);
            this.$dialog.toast({ mes: "處理成功" });
            this.loadData();
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.doctor-audit {
  background-color: rgb(245, 250, 254);
  min-height: 100%;
  .doctor-item {
    margin: 0.2rem;
    background-color: #fff;
    border-radius: 0.2rem;
    padding: 0.2rem;
    .info {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding-bottom: 0.3rem;
      .avatar {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .operation {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      padding-top: 0.2rem;
      border-top: 1px solid rgb(245, 250, 254);
      .no-pass,
      .pass {
        margin-left: 0.4rem;
        padding: 0.2rem;
        border-radius: 0.7rem;
      }
      .pass {
        color: #fff;
        background-color: rgb(64, 105, 255);
      }
      .no-pass {
        border: 1px solid lightgray;
        color: lightgray;
      }
    }
  }
}
</style>
